module.exports = __webpack_public_path__ + "img/tick-white.a6260747.svg";